import PropTypes from 'prop-types'
import React from 'react'

class Dropdown extends React.Component {
  static propTypes = {
    options: PropTypes.array
  }

  static defaultProps = {
    options: []
  }

  renderOptionTags () {
    const { options } = this.props

    return options.map(option => {
      return (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      )
    })
  }

  render () {
    let props = {...this.props}
    delete props.options

    return (
      <select {...props}>
        {this.renderOptionTags()}
      </select>
    )
  }
}

export default Dropdown



// WEBPACK FOOTER //
// ./client/components/dropdown.js